import {Injectable} from "@angular/core";
import {from, map, Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class GeolocationService {

  private readonly BASE_URL = 'https://nominatim.openstreetmap.org/reverse';

  getLocationInfo(lat: number, lon: number): Observable<any | null> {
    const url = `${this.BASE_URL}?lat=${lat}&lon=${lon}&format=json&addressdetails=1`;
    return from(fetch(url).then((res) => res.json())).pipe(
      map((data) => {
        return data;
      })
    );
  }

}
